import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getSubConstructiveAvailableColumns } from './api';

export const path = '/subconstructive/list';

const PageSubConstructiveList: React.FC = (props) => {
  const SubConstructiveList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getSubConstructiveAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <SubConstructiveList {...props} />;
};

export default PageSubConstructiveList;
